import '../css/style.scss';
import nav from "./navigation";
import partners from "./partners";
import imageCompareSlider from "./slider";
import cf7JobForm from "./bewerbungs-form";


document.addEventListener('DOMContentLoaded', function () {
   nav();
   partners();
   imageCompareSlider();
   cf7JobForm();
})